(() => {
if(customElements.get('store-locator')) return;
customElements.define('store-locator',class extends HTMLElement {
connectedCallback(){
 if(this.initialized)return;this.initialized=true;
 const root=this, $=(s,r=root)=>r.querySelector(s), $$=(s,r=root)=>Array.from(r.querySelectorAll(s));
 const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
 const hdH=()=>document.querySelector('sticky-header')?.getBoundingClientRect().height || 0;
 const panelOpen=(panel,open)=>{panel.hidden=!open;panel.style.height=open?'auto':'0';};
 let observerCallback=()=>{};const observer=new ResizeObserver(()=>observerCallback());this.observer=observer;
 const loadMap = frame => {
   if (!frame.dataset.mapSrc || frame.hasAttribute('src') || frame.dataset.mapQueued) return;
   frame.dataset.mapQueued = 'true';
   const applySource = () => {
     if (!frame.isConnected || !frame.dataset.mapSrc) return;
     frame.src = frame.dataset.mapSrc;
     frame.removeAttribute('data-map-src');
     frame.removeAttribute('data-map-queued');
   };
   if ('requestIdleCallback' in window) requestIdleCallback(applySource, { timeout: 1500 });
   else setTimeout(applySource, 500);
 };
 const mapObserver = 'IntersectionObserver' in window
   ? new IntersectionObserver(entries => entries.forEach(entry => {
       if (!entry.isIntersecting) return;
       loadMap(entry.target); mapObserver.unobserve(entry.target);
     }), { rootMargin: '120px 0px' })
   : null;
 this.mapObserver = mapObserver;
 const observeMaps = scope => {
   scope.querySelectorAll('iframe[data-map-src]').forEach(frame => {
     if (mapObserver) mapObserver.observe(frame); else loadMap(frame);
   });
 };
 const safeURL=value=>{try{const u=new URL(value,location.origin);return ['http:','https:'].includes(u.protocol)?u.href:'';}catch{return '';}};
 const visitURL=root.dataset.visitUrl?safeURL(root.dataset.visitUrl):'';
 const googleApiKey=(root.dataset.googleApiKey||'').trim();
 const stateIcons = new Map($$('template[data-state-icon]').map(template => [
   template.dataset.stateIcon.trim().toLowerCase(), template.innerHTML
 ]));
 function storeDisplayName(name, city) {
   let label = name.replace(/^\s*Limelight\s+Lab\s+Grown\s+Diamonds\b\s*[-–—,:|]?\s*/i, '').trim();
   const cityName = city.trim();
   if (cityName && label.toLowerCase().endsWith(cityName.toLowerCase())) {
     const prefix = label.slice(0, -cityName.length);
     if (/[,|–—-]\s*$/.test(prefix)) label = prefix.replace(/\s*[,|–—-]\s*$/, '').trim();
   }
   return label || name;
 }
 const coord=(v,max)=>v!=null && String(v).trim()!=='' && Number.isFinite(Number(v)) && Math.abs(Number(v))<=max?Number(v):null;
 function streetMapURL(map, query) {
   const url = map ? new URL(map) : null;
   if (url && /(^|\.)google\.(com|co\.in)$/.test(url.hostname) &&
       (url.pathname.includes('/maps/embed') || url.searchParams.get('output') === 'embed')) {
     // Match the reference embeds' road-map layer, preserving the store pin and zoom.
     const payload = url.searchParams.get('pb');
     if (payload) url.searchParams.set('pb', payload.replace(/!5e\d+(?=!|$)/g, '!5e0'));
     url.searchParams.set('t', 'm');
     return url.href;
   }
   return 'https://www.google.com/maps?q=' + encodeURIComponent(query) + '&t=m&output=embed';
 }
 const STORES=JSON.parse($('[data-stores]').textContent).map(s=>{
for(const key of ['area','city','state','addr','phone','zip'])s[key]=String(s[key]??'');
  s.zip = s.zip.replace(/\s+/g, '');
  s.lat=coord(s.lat,90);s.lng=coord(s.lng,180);s.sort=Number(s.sort)||0;
  const query=s.lat!==null&&s.lng!==null?s.lat+','+s.lng:[s.area,s.addr,s.city,s.state,s.zip].join(' ');
  const map=safeURL(s.map);
  const coordinateMatch=map.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/)||map.match(/!3d(-?\d+(?:\.\d+)?).*?!4d(-?\d+(?:\.\d+)?)/)||map.match(/[?&](?:q|query)=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
  if(coordinateMatch){s.lat=coord(coordinateMatch[1],90);s.lng=coord(coordinateMatch[2],180);}
  s.embed=streetMapURL(map, query);
  s.direction=safeURL(s.direction)||map||'https://www.google.com/maps/dir/?api=1&destination='+encodeURIComponent(query);
  return s;
 });
 var STATE_ART = {"Andhra Pradesh": "<path d=\"M8 42h32M14 42V18h20v24\"/><path d=\"M14 18h20l-3-5H17zM16 24h16M17 30h14\"/><path d=\"M21 42V34h6v8M24 13V9M22 9h4\"/>", "Bihar": "<path d=\"M8 42h32M14 42V20h20v22\"/><path d=\"M24 6l8 14H16Z\"/><path d=\"M17 26h14M18 32h12M21 42V36h6v6\"/>", "Chhattisgarh": "<path d=\"M7 42h34M13 42V24h22v18\"/><path d=\"M18 24V14h12v10M20 14l4-6 4 6\"/><path d=\"M13 30h22M20 42V34h8v8\"/>", "Delhi": "<path d=\"M5 42h38M10 42V16h28v26\"/><path d=\"M18 42V26a6 6 0 0 1 12 0v16\"/><path d=\"M10 16h28l-2-4H12zM22 12V8h4v4\"/>", "Goa": "<path d=\"M6 42h36M12 42V18h24v24\"/><path d=\"M12 18l12-8 12 8\"/><path d=\"M24 4v6M21.5 6.5h5\"/><path d=\"M20 42V32a4 4 0 0 1 8 0v10M16 24h4M28 24h4\"/>", "Gujarat": "<path d=\"M5 12h38M8 12v6M16 12v6M32 12v6M40 12v6\"/><path d=\"M8 18h32\"/><path d=\"M12 24h24M15 30h18M18 36h12M21 42h6\"/><path d=\"M12 24v-6M36 24v-6M15 30v-6M33 30v-6M18 36v-6M30 36v-6\"/>", "Haryana": "<path d=\"M6 42h36M12 42V16h24v26\"/><path d=\"M12 16h24l-3-5H15z\"/><path d=\"M19 42V28a5 5 0 0 1 10 0v14M16 22h16\"/>", "Jharkhand": "<path d=\"M8 42h32M13 42V22h22v20\"/><path d=\"M24 8c5 6 6 10 6 14H18c0-4 1-8 6-14ZM24 8V5\"/><path d=\"M13 28h22M20 42V34h8v8\"/>", "Karnataka": "<path d=\"M5 42h38M10 42V24h28v18\"/><path d=\"M24 12c4 3 5 7 5 12h-10c0-5 1-9 5-12ZM24 12V8\"/><path d=\"M15 42V32a3 3 0 0 1 6 0v10M27 42V32a3 3 0 0 1 6 0v10\"/><path d=\"M10 24h28\"/>", "Madhya Pradesh": "<path d=\"M5 42h38M9 42V34h30v8\"/><path d=\"M12 34a12 12 0 0 1 24 0\"/><path d=\"M22 15h4M24 15v-4M20 11h8\"/><path d=\"M15 42V36M20 42V36M28 42V36M33 42V36\"/>", "Maharashtra": "<path d=\"M6 42h36M9 42V20h30v22M9 20l3-5h24l3 5\"/><path d=\"M18 42V30a6 6 0 0 1 12 0v12\"/><path d=\"M13 20v-4a2 2 0 0 1 4 0v4M31 20v-4a2 2 0 0 1 4 0v4\"/><path d=\"M15 12a2 2 0 0 1 4 0M29 12a2 2 0 0 1 4 0\"/>", "Punjab": "<path d=\"M4 40h40M12 40V24h24v16\"/><path d=\"M24 14c4 3 5 7 5 10h-10c0-3 1-7 5-10ZM24 14V10\"/><path d=\"M12 24h24M18 40V32h4v8M26 40v-8h4v8\"/><path d=\"M4 44c4-2 6-2 10 0s6 2 10 0 6-2 10 0 6 2 10 0\"/>", "Rajasthan": "<path d=\"M5 42h38M9 42V18h30v24\"/><path d=\"M9 18l15-8 15 8\"/><path d=\"M14 42V32M20 42V32M28 42V32M34 42V32\"/><path d=\"M14 26a2 2 0 0 1 4 0v3h-4zM22 26a2 2 0 0 1 4 0v3h-4zM30 26a2 2 0 0 1 4 0v3h-4z\"/>", "Tamil Nadu": "<path d=\"M6 42h36M12 42V16h24v26\"/><path d=\"M12 16h24l-3-4H15zM14 22h20M15 28h18M16 34h16\"/><path d=\"M21 42V34h6v8M18 12V9M30 12V9\"/>", "Telangana": "<path d=\"M6 42h36M11 42V22h26v20\"/><path d=\"M18 42V32a6 6 0 0 1 12 0v10\"/><path d=\"M11 22h26M13 22V10M35 22V10M13 10a2 2 0 0 1 4 0v12M31 10a2 2 0 0 1 4 0v12\"/><path d=\"M13 8v-2M35 8v-2\"/>", "Uttar Pradesh": "<path d=\"M5 42h38M12 42V26h24v16\"/><path d=\"M24 10c6 4 8 9 8 12H16c0-3 2-8 8-12ZM24 10V6\"/><path d=\"M20 42V32a4 4 0 0 1 8 0v10\"/><path d=\"M9 42V22a1.5 1.5 0 0 1 3 0M36 22a1.5 1.5 0 0 1 3 0v20\"/>", "Uttarakhand": "<path d=\"M4 40h40\"/><path d=\"M4 34l10-14 7 10M20 30l8-12 16 22\"/><path d=\"M18 40V28h12v12M24 28v-4M21 24h6\"/>", "West Bengal": "<path d=\"M3 36h42M8 36V16M40 36V16\"/><path d=\"M8 16h32M8 22h32\"/><path d=\"M8 16l8 6M16 16l-8 6M32 16l8 6M40 16l-8 6M24 16v6\"/><path d=\"M3 42h42M8 36v6M40 36v6\"/>"};

  function initLocator() {
    var wrap = $("[data-el=locWrap]");
    if (!wrap || typeof STORES === "undefined") return;

    var railHost = $("[data-el=locCities]"),
        search   = $("[data-el=locSearch]"),
        count    = $("[data-el=locCount]");
    var nearButton = $('[data-el=locNear]'), locationStatus = $('[data-location-status]'), nearbyCredit = $('[data-nearby-credit]');
      var floatingVisit = $('[data-floating-visit]'), floatingTick = false;
    function updateFloatingVisit() {
      floatingTick = false;
      if (!floatingVisit) return;
      var bounds = wrap.getBoundingClientRect();
      var hasStores = !!wrap.querySelector('.locRow');
      var buttonBottom = innerWidth <= 640 ? 18 : 28;
      var buttonTop = innerHeight - buttonBottom - floatingVisit.offsetHeight;
      // Hide before the fixed button would visually cross into the next section.
      var visible = hasStores && bounds.top <= innerHeight * .72 && bounds.bottom > buttonTop;
      floatingVisit.classList.toggle('is-visible', visible);
      floatingVisit.setAttribute('aria-hidden', visible ? 'false' : 'true');
      floatingVisit.tabIndex = visible ? 0 : -1;
    }
    function requestFloatingUpdate() {
      if (floatingTick) return;
      floatingTick = true;
      requestAnimationFrame(updateFloatingVisit);
    }
    root.onFloatingScroll = requestFloatingUpdate;
    addEventListener('scroll', requestFloatingUpdate, { passive: true });
    addEventListener('resize', requestFloatingUpdate);

    if (floatingVisit) floatingVisit.addEventListener('click', function (event) {
      var form = document.querySelector('[data-el="visitForm"]');
      if (!form) return;

      event.preventDefault();
      if (form.id && location.hash !== '#' + form.id) {
        history.pushState(null, '', location.pathname + location.search + '#' + form.id);
      }
      scrollTo({
        top: form.getBoundingClientRect().top + scrollY - hdH() - 24,
        behavior: reduced ? 'auto' : 'smooth'
      });
      var first = $('input', form);
      if (first) setTimeout(function () { first.focus(); }, reduced ? 0 : 420);
    });
    
    count.classList.add("sr-only");

    var city = "";        
    var pickedCity = "";  
    var nearMode = false;

    function setLocationStatus(message) {
      if (!locationStatus) return;
      locationStatus.textContent = message || '';
      locationStatus.hidden = !message;
    }
    async function fetchJSON(url, timeout) {
      var controller=new AbortController();
      var timer=setTimeout(function(){controller.abort();},timeout||12000);
      try{
        var response=await fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error('HTTP '+response.status);
        return await response.json();
      }finally{clearTimeout(timer);}
    }
    async function postcodeCoordinates(zip) {
      if(!/^[1-9]\d{5}$/.test(zip))return null;
      var cacheKey='store-locator-postcode-v1:'+zip;
      try{
        var cached=JSON.parse(localStorage.getItem(cacheKey));
        if(cached&&coord(cached.lat,90)!==null&&coord(cached.lng,180)!==null)return cached;
      }catch(_){}
      try{
        var data=await fetchJSON('https://api.zippopotam.us/IN/'+encodeURIComponent(zip),10000);
        var place=data.places&&data.places[0];
        var point=place?{lat:coord(place.latitude,90),lng:coord(place.longitude,180)}:null;
        if(!point||point.lat===null||point.lng===null)return null;
        try{localStorage.setItem(cacheKey,JSON.stringify(point));}catch(_){}
        return point;
      }catch(_){return null;}
    }
    async function addPostcodeCoordinates() {
      var pending=STORES.filter(function(store){return store.lat===null||store.lng===null;});
      var byZip={};
      pending.forEach(function(store){if(store.zip)(byZip[store.zip]||(byZip[store.zip]=[])).push(store);});
      var zips=Object.keys(byZip),cursor=0;
      async function worker(){
        while(cursor<zips.length){
          var zip=zips[cursor++],point=await postcodeCoordinates(zip);
          if(point)byZip[zip].forEach(function(store){store.lat=point.lat;store.lng=point.lng;});
        }
      }
      await Promise.all(Array.from({length:Math.min(6,zips.length)},worker));
    }
    async function addDrivingDistances(userLat,userLng) {
      var located=STORES.filter(function(store){return store.lat!==null&&store.lng!==null;});
      STORES.forEach(function(store){store.distance=null;store.driveMinutes=null;});
      for(var offset=0;offset<located.length;offset+=20){
        var batch=located.slice(offset,offset+20);
        var coordinates=[[userLng,userLat]].concat(batch.map(function(store){return[store.lng,store.lat];}));
        var path=coordinates.map(function(point){return point[0]+','+point[1];}).join(';');
        var destinations=batch.map(function(_,index){return index+1;}).join(';');
        var url='https://router.project-osrm.org/table/v1/driving/'+path+'?sources=0&destinations='+destinations+'&annotations=distance,duration';
        var data=await fetchJSON(url,20000);
        if(data.code!=='Ok'||!data.distances||!data.distances[0])throw new Error('The driving-distance service returned an invalid response.');
        batch.forEach(function(store,index){
          var metres=data.distances[0][index],seconds=data.durations&&data.durations[0]?data.durations[0][index]:null;
          store.distance=Number.isFinite(metres)?metres/1000:null;
          store.driveMinutes=Number.isFinite(seconds)?Math.round(seconds/60):null;
        });
      }
    }
    async function locateStores() {
      if (!navigator.geolocation) throw new Error('Location is not supported by this browser.');
      var position = await new Promise(function(resolve,reject){
        navigator.geolocation.getCurrentPosition(resolve,reject,{enableHighAccuracy:true,timeout:12000,maximumAge:300000});
      });
      var userLat=position.coords.latitude,userLng=position.coords.longitude;
      setLocationStatus('Finding store PIN locations…');
      await addPostcodeCoordinates();
      if(!STORES.some(function(store){return store.lat!==null&&store.lng!==null;}))throw new Error('No store PIN codes could be located by the test postcode service.');
      setLocationStatus('Calculating driving distances…');
      await addDrivingDistances(userLat,userLng);
      if(!STORES.some(function(store){return Number.isFinite(store.distance);}))throw new Error('Driving distances are currently unavailable. Please try again.');
      city=''; pickedCity=''; search.value=''; openSku=null; nearMode=true;
      buildCities(); render();
      setLocationStatus('Nearest stores');
      if(nearbyCredit)nearbyCredit.hidden=false;
      scrollTo({top:wrap.getBoundingClientRect().top+scrollY-hdH()-24,behavior:reduced?'auto':'smooth'});
    }  

    
    var TOP = null;                       
    function stateCount(st) {
      return STORES.filter(function (s) { return s.state === st; }).length;
    }
    function citiesIn(st) {
      var o = [];
      STORES.forEach(function (s) {
        if (s.state === st && o.indexOf(s.city) < 0) o.push(s.city);
      });
      return o.length;
    }
    var STATES = [];
    STORES.forEach(function (s) { if (STATES.indexOf(s.state) < 0) STATES.push(s.state); });
    STATES.sort(function (a, b) { return a.localeCompare(b); });

    city = STATES.indexOf("Maharashtra") > -1 ? "Maharashtra" : (STATES[0] || "");
    pickedCity = STORES.some(function (store) { return store.state === city && store.city === "Mumbai"; }) ? "Mumbai" : "";

    function chooseState(state, shouldScroll) {
      clearSearchForSelection();
      city = state;
      pickedCity = state === "Maharashtra" && STORES.some(function (store) {
        return store.state === state && store.city === "Mumbai";
      }) ? "Mumbai" : "";
      buildCities();
      render();
      if (shouldScroll) scrollTo({
        top: wrap.getBoundingClientRect().top + scrollY - hdH() - 24,
        behavior: reduced ? "auto" : "smooth"
      });
    }

    function buildCities() {
      railHost.innerHTML = "";
      STATES.forEach(function (st) {
        var n = stateCount(st), c = citiesIn(st);
        var b = document.createElement("button");
        b.className = "locCity";
        b.type = "button";
        b.setAttribute("aria-pressed", st === city ? "true" : "false");
        b.innerHTML =
          (stateIcons.get(st.trim().toLowerCase()) || ('<svg viewBox="0 0 48 48" aria-hidden="true">' +
          ((typeof STATE_ART !== "undefined" && STATE_ART[st]) || '<path d="M8 40V16l16-8 16 8v24M4 40h40M16 40V24h16v16M20 16h8"/>') + "</svg>")) +
          '<span class="locCity__n">' + esc(st) + "</span>" +
          '<span class="locCity__c">' + n + (n === 1 ? " STORE" : " STORES") +
          " &middot; " + c + (c === 1 ? " CITY" : " CITIES") + "</span>";
        b.addEventListener("click", function () {
          chooseState(st, true);
        });
        railHost.appendChild(b);
      });
      syncArrows();
      var active = railHost.querySelector('[aria-pressed="true"]');
      if (active) requestAnimationFrame(function () {
        railHost.scrollTo({
          left: Math.max(0, active.offsetLeft - (railHost.clientWidth - active.offsetWidth) / 2),
          behavior: reduced ? "auto" : "smooth"
        });
      });
    }

    
    var prevB = $("[data-el=cityPrev]"), nextB = $("[data-el=cityNext]");
    function syncArrows() {
      if (!prevB || !nextB) return;
      if (!root.isConnected) return;
      var max = railHost.scrollWidth - railHost.clientWidth;
      prevB.disabled = railHost.scrollLeft <= 2;
      nextB.disabled = railHost.scrollLeft >= max - 2;
    }
    function nudge(dir) {
      railHost.scrollBy({ left: dir * Math.max(300, railHost.clientWidth * 0.8),
                          behavior: reduced ? "auto" : "smooth" });
    }
    if (prevB) prevB.addEventListener("click", function () { nudge(-1); });
    if (nextB) nextB.addEventListener("click", function () { nudge(1); });
    railHost.addEventListener("scroll", function () {
      if (railHost._t) return;
      railHost._t = requestAnimationFrame(function () {
        railHost._t = null;
        syncArrows();
      });
    }, { passive: true });
    observer.observe(railHost);

    
    var openSku = null;

    function storeKey(s) { return String(s.id); }

    function citiesOf(st) {
      var m = {};
      STORES.forEach(function (s) { if (s.state === st) m[s.city] = (m[s.city] || 0) + 1; });
      return Object.keys(m).sort(function (a, b) { return a.localeCompare(b); })
        .map(function (c) { return { city: c, n: m[c] }; });
    }

    function detailHTML(s) {
      
      return '<div class="locDetail">' +
        '<div class="locDetail__info">' +
          '<p class="locDetail__a">' + esc(s.addr) +
            (s.zip ? "<br>" + esc(s.city) + " " + esc(s.zip) : "") + "</p>" +
          (s.phone ? '<p class="locDetail__phone"><a href="tel:' +
            esc(s.phone.replace(/[^\d+]/g, '')) + '">' + esc(s.phone) + '</a></p>' : '') +
          '<div class="locDetail__act">' +
            (visitURL ? '<a class="btn locVisit" data-book="' + esc(s.area + ', ' + s.city) + '" href="' + esc(visitURL) + '">SCHEDULE A VISIT</a>' : '') +
            '<a class="locCard__b" href="' + esc(s.direction) + '"' +
            (s.direction ? ' target="_blank" rel="noopener"' : "") +
            '><span>DIRECTIONS</span>' +
            '<svg class="arw" viewBox="0 0 24 24" aria-hidden="true">' +
            '<path d="M7 17 17 7M9 7h8v8"/></svg></a>' +
          "</div>" +
        "</div>" +
        '<div class="locDetail__map">' +
          (s.embed
            ? '<iframe loading="lazy" referrerpolicy="no-referrer-when-downgrade" ' +
              'title="Map of ' + esc(s.area + ", " + s.city) + '" data-map-src="' +
              esc(s.embed) + '"></iframe>'
            : '<p class="locDetail__off">No map for this counter yet.</p>') +
        "</div>" +
      "</div>";
    }

    function buildScope(hits) {
      
      var opts = (city && hits.length) ? citiesOf(city) : [];
      var heading = city || "All stores";
      var sub = !hits.length ? "" : (hits.length + (hits.length === 1 ? " STORE" : " STORES") + " &middot; " +
           uniq(hits, "city").length + (uniq(hits, "city").length === 1 ? " CITY" : " CITIES"));
      var sel = opts.length
        ? ('<label class="sr-only" for="' + root.id + '-city">Choose a city</label>' +
           '<select class="locScope__sel" id="' + root.id + '-city" data-el="citySel">' +
           '<option value="">All cities</option>' +
           opts.map(function (o) {
             return '<option value="' + esc(o.city) + '"' +
               (pickedCity === o.city ? " selected" : "") + '>' +
               esc(o.city) + " (" + o.n + ")</option>";
           }).join("") +
           "</select>")
        : "";
      return '<div class="locScope"><div class="locScope__h">' +
        '<h2 class="locScope__n">' + esc(heading) + '</h2>' +
        (sub ? '<span class="locScope__c">' + sub + '</span>' : "") + '</div>' +
        '<div class="locScope__ctrls">' +
        '<button class="locCard__b" type="button" data-el="collapseAll" hidden>' +
        'COLLAPSE ALL</button>' + sel + '</div></div>';
    }

    function buildStores(hits) {
      var host = $("[data-el=store]", wrap);
      if (!host) return;

      
      var current = hits.filter(function (s) { return storeKey(s) === openSku; })[0];
      if (!current) { current = hits[0]; openSku = current ? storeKey(current) : null; }

      
      var rows = hits.map(function (s) {
        var key = storeKey(s), open = key === openSku;
        return '<li class="locRow' + (open ? " is-open" : "") + '" data-key="' + esc(key) + '">' +
          '<button class="locRow__t" type="button" aria-expanded="' + (open ? "true" : "false") + '">' +
            '<span class="locRow__i">' +
              '<span class="locRow__n">' + esc(storeDisplayName(s.area, s.city)) + "</span>" +
              '<span class="locRow__c">' + esc(s.city) +
                (nearMode && Number.isFinite(s.distance) ? ' · ' + esc(s.distance.toFixed(1)) + ' KM DRIVE' : '') + "</span>" +
            "</span>" +
            '<span class="uSec__m" aria-hidden="true"></span>' +
          "</button>" +
          '<div class="locRow__b">' + (open ? detailHTML(s) : "") + "</div>" +
        "</li>";
      }).join("");

      host.innerHTML = '<ul class="locList" data-el="list">' + rows + "</ul>";
      observeMaps(host);

      $$(".locRow", host).forEach(function (li) {
        var btn = $(".locRow__t", li), panel = $(".locRow__b", li);
        var key = li.getAttribute("data-key");
        var s = hits.filter(function (x) { return storeKey(x) === key; })[0];
        panel.style.height = li.classList.contains("is-open") ? "auto" : "0";
        panel.hidden = !li.classList.contains("is-open");
        panel.id = root.id + '-panel-' + STORES.indexOf(s);
        btn.setAttribute('aria-controls', panel.id);
        btn.addEventListener("click", function () {
          var opening = !li.classList.contains("is-open");
          li.classList.toggle("is-open", opening);
          btn.setAttribute("aria-expanded", opening ? "true" : "false");
          if (opening) {
            if (!panel.childElementCount) panel.innerHTML = detailHTML(s);
            observeMaps(panel);
            openSku = key;
          }
          panelOpen(panel, opening);
          refreshCollapse();
        });
      });
    }

    
    function compareStores(a, b) {
      if (nearMode) {
        var ad=Number.isFinite(a.distance)?a.distance:Infinity;
        var bd=Number.isFinite(b.distance)?b.distance:Infinity;
        if(ad!==bd)return ad-bd;
      }
      return a.sort - b.sort || a.city.localeCompare(b.city) || a.area.localeCompare(b.area);
    }

    function esc(t) {
      return String(t).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    
    function refreshCollapse() {
      var btn = $("[data-el=collapseAll]", wrap);
      if (!btn) return;
      btn.hidden = $$(".locRow.is-open", wrap).length < 2;
    }

    function render(updatePickers = true) {
      if (updatePickers) syncPickers();
      var q = (search.value || "").trim().toLowerCase();
      if (/^[\d\s]+$/.test(q)) q = q.replace(/\s+/g, '');
      var isPin = /^[1-9]\d{5}$/.test(q);

      var hits = STORES.filter(function (s) {
        if (!isPin && city && s.state !== city) return false;
        if (!isPin && pickedCity && s.city !== pickedCity) return false;
        if (!q) return true;
        if (isPin) return s.zip === q;
        return (s.area + " " + s.city + " " + s.state + " " + s.addr + " " + s.zip)
                 .toLowerCase().indexOf(q) > -1;
      });
      var pinMessage = '';
      if (isPin && !hits.length) {
        const prefix = q.slice(0, 3);
        hits = STORES.filter(s => /^[1-9]\d{5}$/.test(s.zip) && s.zip.startsWith(prefix));
        pinMessage = hits.length 
          ? 'Nearest Stores'
          : 'No stores match PIN ' + q + '. Please search by city or select a state.';
      }
      if (nearMode) {
        hits = hits.filter(function (store) {
          return Number.isFinite(store.distance) && store.distance <= 100;
        });
        pinMessage = hits.length
          ? 'Nearest first'
          : 'No stores found within 100 km of your current location.';
      }
      
      count.textContent = hits.length
        ? hits.length + (hits.length === 1 ? " STORE" : " STORES") +
          " IN " + uniq(hits, "city").length +
          (uniq(hits, "city").length === 1 ? " CITY" : " CITIES")
        : "NO STORES MATCH";

      hits.sort(compareStores);

      wrap.innerHTML = buildScope(hits) +
        (pinMessage ? '<p class="locPinMessage" role="status">' + esc(pinMessage) + '</p>' : '') +
        (hits.length ? '<div class="locStore" data-el="store"></div>' : "");
        requestFloatingUpdate();

      var collapseBtn = $("[data-el=collapseAll]", wrap);
      if (collapseBtn) collapseBtn.addEventListener("click", function () {
        $$(".locRow.is-open", wrap).forEach(function (li) {
          var b = $(".locRow__t", li), p = $(".locRow__b", li);
          li.classList.remove("is-open");
          b.setAttribute("aria-expanded", "false");
          panelOpen(p, false);
        });
        refreshCollapse();
      });

      var sel = $("[data-el=citySel]", wrap);
      if (sel) sel.addEventListener("change", function () {
        clearSearchForSelection();
        pickedCity = sel.value;
        render();
      });

      if (!hits.length) {
        var e = document.createElement("div");
        e.className = "locEmpty";
        e.innerHTML = '<p>We have no counter matching that yet — but we open new ' +
          'stores often, and everything is available to order online.</p>' +
          '<button class="locVisit" type="button" data-el="locReset">' +
          'CLEAR FILTERS</button>';
        wrap.appendChild(e);
        $("[data-el=locReset]", e).addEventListener("click", function () {
          clearTimeout(searchTimer);
          city = ""; pickedCity = ""; search.value = "";
          buildCities();
          render();
        });
        return;
      }

      buildStores(hits);
      refreshCollapse();
    }

    function uniq(list, key) {
      var o = [];
      list.forEach(function (s) { if (o.indexOf(s[key]) < 0) o.push(s[key]); });
      return o;
    }

    var searchTimer;
    function runSearch() {
      // Search the whole catalogue instead of restricting queries to the default state.
      city = ''; pickedCity = ''; openSku = null; nearMode = false;
      if (nearbyCredit) nearbyCredit.hidden=true;
      setLocationStatus('');
      buildCities(); render();
    }
    search.addEventListener('input', function () {
      clearTimeout(searchTimer); searchTimer = setTimeout(runSearch, 200);
    });
    search.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') { event.preventDefault(); clearTimeout(searchTimer); runSearch(); }
    });

    if (nearButton) nearButton.addEventListener('click', function () {
      if (nearButton.classList.contains('is-busy')) return;
      var nearLabel=nearButton.querySelector('span');
      var originalNearLabel=nearLabel?nearLabel.textContent:'LOCATE ME';
      nearButton.classList.add('is-busy');
      nearButton.setAttribute('aria-busy','true');
      if(nearLabel)nearLabel.textContent='LOCATING…';
      if(nearbyCredit)nearbyCredit.hidden=true;
      nearButton.setAttribute('aria-pressed','true');
      setLocationStatus('Finding your location and calculating nearby stores…');
      locateStores().catch(function(error){
        nearMode=false;
        nearButton.setAttribute('aria-pressed','false');
        var message=error&&error.code===1
          ? 'Location permission was denied. Allow location access in your browser and try again.'
          : error&&error.code===2
            ? 'Your current location is unavailable. Check device location services and try again.'
            : error&&error.code===3
              ? 'Location request timed out. Please try again.'
              : (error.message||'Unable to find your location. Please try again.');
        setLocationStatus(message);
      }).finally(function(){
        nearButton.classList.remove('is-busy');
        nearButton.removeAttribute('aria-busy');
        if(nearLabel)nearLabel.textContent=originalNearLabel;
      });
    });

    wrap.addEventListener("click", function (e) {
      var b = e.target.closest("[data-book]");
      if (!b) return;
      root.dispatchEvent(new CustomEvent("store-locator:visit", {bubbles:true,detail:{store:b.getAttribute("data-book")}}));
      var form = document.querySelector("[data-el=visitForm]");
      if (!form) return;
      if (new URL(b.href).hash) e.preventDefault();
      var f = $('[name="store"]', form);
      if (f) f.value = b.getAttribute("data-book");
      scrollTo({ top: form.getBoundingClientRect().top + scrollY - hdH() - 24,
                 behavior: reduced ? "auto" : "smooth" });
      var first = $("input", form);
      if (first) setTimeout(function () { first.focus(); }, reduced ? 0 : 420);
    });

    
    function syncPickers() {
      const st=$('[data-state]'), railState=$('[data-state-rail]'), cy=$('[data-city]');
      const stateOptions='<option value="">Select your State</option>'+STATES.map(s=>'<option value="'+esc(s)+'">'+esc(s)+' ('+stateCount(s)+')</option>').join('');
      st.innerHTML=stateOptions;st.value=city;
      if(railState){railState.innerHTML=stateOptions;railState.value=city;}
      const cities=uniq(STORES.filter(s=>!city || s.state===city),'city').filter(Boolean).sort();
      cy.innerHTML='<option value="">Select your City</option>'+cities.map(c=>'<option value="'+esc(c)+'">'+esc(c)+'</option>').join('');cy.value=pickedCity;
    }
    function clearSearchForSelection() {
      clearTimeout(searchTimer);
      search.value = '';
      openSku = null;
      nearMode = false;
      if (nearButton) nearButton.setAttribute('aria-pressed','false');
      if (nearbyCredit) nearbyCredit.hidden=true;
      setLocationStatus('');
    }
    ['[data-state]', '[data-city]'].forEach(selector => {
      $(selector).addEventListener('focus', () => {
        if (!search.value) return;
        clearSearchForSelection();
        // Keep the focused native select and its options intact while clearing results.
        render(false);
      });
    });
    $('[data-state]').addEventListener('change',e=>chooseState(e.target.value,false));
    const railState=$('[data-state-rail]');
    if(railState)railState.addEventListener('change',e=>chooseState(e.target.value,false));
    $('[data-city]').addEventListener('change',e=>{const selected=e.target.value;clearSearchForSelection();pickedCity=selected;render();});
    observerCallback=syncArrows;
    observeMaps(root);
    buildCities();
    render();
  }


initLocator();
}
disconnectedCallback(){this.observer?.disconnect();this.mapObserver?.disconnect();removeEventListener('scroll',this.onFloatingScroll);removeEventListener('resize',this.onFloatingScroll);this.initialized=false;}
});
})();
